import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-angular-inputs-validation',
  template: `
    <p>
      angular-inputs-validation works!
    </p>
  `,
  styles: [
  ]
})
export class AngularInputsValidationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
